import { useEffect, useState } from 'react';

/**
 * iOS Safari doesn't shrink the layout viewport (what `position: fixed` pins
 * to) when the on-screen keyboard opens — only `window.visualViewport` does.
 * This tracks the gap between the two so a fixed-to-bottom sheet can offset
 * itself above the keyboard instead of sitting under it. Returns 0 (a no-op)
 * on browsers that already resize the layout viewport for the keyboard.
 */
export function useKeyboardInset() {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) {
      return;
    }

    const update = () => {
      const value = window.innerHeight - viewport.height - viewport.offsetTop;
      setInset(Math.max(0, Math.round(value)));
    };

    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
    };
  }, []);

  return inset;
}
